import { Eye, EyeOff } from 'lucide-react'
import { useState } from 'react'

type PasswordInputProps = {
  id: string
  name: string
  value: string
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  autoComplete?: string
  placeholder?: string
  required?: boolean
  onFocus?: () => void
  onBlur?: () => void
  testId?: string
}

export function PasswordInput({
  id,
  name,
  value,
  onChange,
  autoComplete,
  placeholder,
  required = true,
  onFocus,
  onBlur,
  testId,
}: PasswordInputProps) {
  const [visible, setVisible] = useState(false)

  return (
    <div className="relative mt-1">
      <input
        id={id}
        name={name}
        type={visible ? 'text' : 'password'}
        autoComplete={autoComplete}
        required={required}
        value={value}
        onChange={onChange}
        onFocus={onFocus}
        onBlur={onBlur}
        data-testid={testId}
        className="appearance-none relative block w-full px-3 py-2 pr-10 border border-border-strong placeholder:text-text-muted text-text-primary rounded-md bg-surface-default focus:outline-none focus:ring-2 focus:ring-interactive-focus-ring focus:border-interactive text-small"
        placeholder={placeholder}
      />
      <button
        type="button"
        tabIndex={-1}
        onMouseDown={(event) => event.preventDefault()}
        onClick={() => setVisible((current) => !current)}
        className="absolute inset-y-0 right-0 z-10 flex items-center px-3 text-text-muted hover:text-text-secondary focus:outline-none focus-visible:ring-2 focus-visible:ring-interactive-focus-ring rounded-r-md"
        aria-label={visible ? 'Hide password' : 'Show password'}
        aria-pressed={visible}
        data-testid={testId ? `${testId}-visibility-toggle` : `${id}-visibility-toggle`}
      >
        {visible ? <EyeOff className="h-4 w-4" aria-hidden /> : <Eye className="h-4 w-4" aria-hidden />}
      </button>
    </div>
  )
}
